export default __webpack_public_path__ + "static/media/chevron-left-blue.b3e4ccf7.svg";